var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import AlertCard from '@/components/alert-card/AlertCard';
import AreaRow from '@/components/area-row/AreaRow';
import AsyncSelect from '@/components/async-select/AsyncSelect';
import DataTable from '@/components/data-table/DataTable';
import LoaderCard from '@/components/loader-card/LoaderCard';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { Curriculum } from '@/models/Curriculum';
import { Event as EventModel } from '@/models/Event';
import { LessonType } from '@/models/LessonType';
import { Student } from '@/models/Student';
import { Subject } from '@/models/Subject';
import { UserSubjectSummary } from '@/models/UserSubjectSummary';
import ErrorHandler from '@/support/ErrorHandler';
import { lessonTypeIcons, whiteAreaIcons, whiteKidIcons } from '@/support/Icon';
import Storage from '@/support/Storage';
import { avatarHtml, replaceUrlsWithAnchorTags } from '@/support/String';
import { DateTime } from 'luxon';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import SubjectSearchDialog from '@/views/Users/Teacher/SubjectSearchDialog';
import StudentOverviewTableDialog from './StudentOverviewTableDialog';
import { UserSubjectStatusEnum } from '@/models/UserSubject';
import { RolesEnum } from '@/items/Roles';
let EditEventDialog = class EditEventDialog extends Vue {
    constructor() {
        super(...arguments);
        this.visibility = {
            checkboxes: false,
        };
        this.detailedEvent = null;
        this.filters = {
            periods: [],
            levels: [],
            subject_labels: [],
        };
        this.checkboxes = {
            inviteCompleted: false,
            inviteNotInClassActive: false,
            inviteNotInPlP: false,
        };
        this.showSubjectSearchDialog = false;
        this.currentStep = 1;
        this.areas = [];
        this.isLoading = true;
        this.isLoadingStepThree = false;
        this.curriculum = new Curriculum();
        this.selectedLessonType = null;
        this.selectedStudents = null;
        this.description = '';
        this.canSelectStudents = false;
        this.isInvited = false;
        this.isMandatory = false;
        this.invitations = {};
        this.lessonTypes = null;
        this.lessonTypeIcons = null;
        this.updateUserList = [];
        this.totalStudents = [];
        this.activeStudents = [];
        this.finishedStudents = [];
        this.notInClassActiveStudents = [];
        this.notInPlpStudents = [];
        this.levelStudents = [];
        this.groupStudents = [];
        this.templates = [];
        this.clearSelects = false;
        this.isLoadingLessonType = true;
        this.isSubjectSummaryLoaded = false;
        this.isShowingStudentOverviewTable = false;
        this.isLoadingMandatoryUsers = true;
        this.defaultEventUsers = [];
        this.invitedEventUsers = [];
        this.parsedDescription = '';
        this.rules = {
            counter: (value) => {
                return value.length <= 250 || 'Max 250 characters';
            },
        };
        this.userSubjects = {
            rows: [],
            totals: {
                finished: 0,
                unfinished: 0,
            },
        };
    }
    onStudentOverviewClick() {
        this.$router.replace({
            query: {
                ...this.$route.query ? { ...this.$route.query } : {},
                event: this.event.id,
            },
        });
        this.$nextTick(() => this.$nextTick(() => {
            this.isShowingStudentOverviewTable = true;
        }));
    }
    get getTopicHeader() {
        if (this.detailedEvent && this.detailedEvent.topics && this.detailedEvent.topics.length) {
            return `${this.$tc('subject.topic.title', 1)}: ${this.detailedEvent.topics[0].name}`;
        }
        if (this.detailedEvent && this.detailedEvent.areas && this.detailedEvent.areas.length) {
            return `${this.$tc('subject.area.title', 1)}: ${this.detailedEvent.areas[0].name}`;
        }
        return '';
    }
    get uniqueDefaultCount() {
        const count = this.activeStudents.length + this.finishedStudents.length + this.notInPlpStudents.length;
        return `${count} ${this.$tc('roles.student', count)}`;
    }
    get hasNotInPlpStudents() {
        return this.notInPlpStudents.length;
    }
    get hasfinishedStudents() {
        return this.finishedStudents.length;
    }
    get hasMandatory() {
        let mandatory = false;
        if (this.detailedEvent) {
            if (this.detailedEvent.groups) {
                this.detailedEvent.groups.forEach((group) => {
                    if (group.is_mandatory) {
                        mandatory = true;
                    }
                });
            }
            if (this.detailedEvent.levels) {
                if (this.detailedEvent.levels) {
                    this.detailedEvent.levels.forEach((level) => {
                        if (level.is_mandatory) {
                            mandatory = true;
                        }
                    });
                }
            }
        }
        return mandatory;
    }
    get tableOptions() {
        return {
            name: {
                singular: 'Student',
                plural: 'Students',
            },
            headers: [
                {
                    text: '',
                    value: 'avatar',
                    transform: avatarHtml,
                },
                {
                    text: this.$t('name.title'),
                    value: 'name',
                },
            ],
            actions: [],
            filters: [],
            dropdown: [],
            model: new Student(),
        };
    }
    get selectedSubjects() {
        if (!this.$store.state.selected) {
            return [];
        }
        const invitations = {};
        this.$store.state.selected.forEach((subject) => {
            if (subject.id && !invitations[subject.id]) {
                invitations[subject.id] = {
                    active: {
                        is_invited: false,
                        is_mandatory: false,
                    },
                    finished: {
                        is_invited: false,
                        is_mandatory: false,
                    },
                    other: {
                        is_invited: false,
                        is_mandatory: false,
                    },
                };
            }
        });
        this.invitations = { ...this.invitations, ...invitations };
        return this.$store.state.selected || [];
    }
    get whiteIcons() {
        const type = Storage.get('type');
        return type && type.toLowerCase() === 'po' ? whiteAreaIcons : whiteKidIcons;
    }
    get parsedDescriptionText() {
        if (this.detailedEvent && this.detailedEvent.description) {
            return replaceUrlsWithAnchorTags(this.detailedEvent.description);
        }
        return '';
    }
    get countInvitedUsers() {
        return this.getInvitedUsers().length || 0;
    }
    get countMandatoryUsers() {
        const users = this.getInvitedUsers();
        return users.filter((user) => user.is_mandatory).length || 0;
    }
    get visibleStudents() {
        return this.$store.state.settings.find((setting) => setting.key === 'visibility_date_students');
    }
    get isBeforeVisibleStudent() {
        if (this.event && this.event.starts_at && this.visibleStudents) {
            const eventStart = DateTime.fromFormat(this.event.starts_at, 'dd-LL-yyyy HH:mm').toFormat('yyyy-LL-dd');
            if (eventStart <= this.visibleStudents.value) {
                return true;
            }
        }
        return false;
    }
    get curriculumFilters() {
        const filter = {};
        Object.keys(this.filters).forEach((key) => {
            if (this.filters[key].length === 0) {
                return;
            }
            filter[key] = this.filters[key];
        });
        return filter;
    }
    mounted() {
        this.lessonTypeIcons = lessonTypeIcons;
        this.initialize();
    }
    initialize() {
        this.currentStep = 1;
        this.isLoading = true;
        this.areas = [];
        this.filters = {
            periods: [],
            levels: [],
            subject_labels: [],
        };
        this.fetchEvent();
    }
    // public get attachableUsers()
    // {
    //   return this.getInvitedUsers();
    // }
    // setLevelStudents(level: Level) {
    //   const users = level.users ? level.users : [];
    //   users.forEach((student: User) => {
    //     if (student.id) {
    //       if (this.totalStudents.map(function(student) { return student.id; }).indexOf(student.id) < 0) {
    //         this.totalStudents.push({
    //           id: student.id,
    //           is_mandatory: level.is_mandatory || false,
    //           is_chosen: false,
    //         });
    //         this.levelStudents.push(student.id);
    //       }
    //     }
    //   });
    // }
    // protected setGroups() {
    //   if (!this.detailedEvent) {
    //     return;
    //   }
    //   const groups = this.detailedEvent.groups ? this.detailedEvent.groups : [];
    //   groups.forEach((group: Group) => {
    //     if (!group.users) {
    //       return;
    //     }
    //     (group.users as User[]).forEach((user: User) => {
    //       if (!user.id) {
    //         return;
    //       }
    //       if (user.roles && user.roles[0].id === 'teacher') {
    //         return;
    //       }
    //       if (this.totalStudents.map(function(e) { return e.id; }).indexOf(user.id) < 0) {
    //         this.totalStudents.push({
    //           id: user.id,
    //           is_mandatory: group.is_mandatory || false,
    //           is_chosen: false,
    //         });
    //         this.groupStudents.push(user.id);
    //       }
    //     });
    //   });
    // }
    getSubjects(extendedFilters = {}) {
        extendedFilters.curriculum = this.curriculum.id;
        if (this.detailedEvent && this.detailedEvent.subjects) {
            const areas = [];
            this.detailedEvent.subjects.forEach((subject) => {
                if (subject.id && subject.depth === 0) {
                    areas.push(subject.id);
                }
            });
            extendedFilters.areas = areas;
        }
        Object.keys(this.filters).forEach((key) => {
            if (this.filters[key] === null || this.filters[key].length === 0) {
                return;
            }
            extendedFilters[key] = this.filters[key];
        });
        new Subject()
            .filter(extendedFilters)
            .include('children')
            .limit(100)
            .all()
            .then((subjects) => {
            if (!subjects) {
                return;
            }
            if (!this.detailedEvent) {
                this.areas = subjects;
            }
            else {
                this.areas = this.sortByEventArea(subjects);
            }
            this.curriculum.subjects = subjects;
            this.isLoading = false;
        });
        if (this.detailedEvent && (this.detailedEvent.updated_at !== this.detailedEvent.created_at)) {
            this.setSelectedSubjects();
        }
        // preload Lesson Types
        this.initializeLessonTypeStep();
    }
    // public filterCurriculum() {
    //   if (!this.selectedSubjects) {
    //     return;
    //   }
    //   this.selectedSubjects.forEach((selectedSubject: Subject) => {
    //     if (!selectedSubject.parent) {
    //       return;
    //     }
    //     this.$store.state.curriculum.subjects.forEach((area: Subject) => {
    //       if (!area.children) {
    //         return;
    //       }
    //       const topics = area.children.filter((subject: Subject) => {
    //         return subject.id === (selectedSubject.parent as any).id;
    //       });
    //       if (topics.length) {
    //         (selectedSubject.parent as Subject).parent = area;
    //       }
    //     });
    //   });
    // }
    getSubjectById(id) {
        // return this.userSubjects.rows.find((studentSubject: SubjectSummaryResponseRow) => {
        //   //
        // })
    }
    getSubjectStatusCount(subject, isCurrent = true) {
        const totals = {
            highlighted: 0,
            busy: 0,
            old: 0,
            closed: 0,
            finished: 0,
            future: 0,
            inactive: 0,
        };
        // this.userSubjects.rows.forEach((userSubject: SubjectSummaryResponseRow, index: number) => {
        //   if (userSubject.subject !== subject.id) {
        //     totals['inactive'] += 1;
        //   }
        //   if (isCurrent && userSubject.level.is_current === false) {
        //     return;
        //   }
        //   if (! isCurrent && userSubject.level.is_current === true) {
        //     return;
        //   }
        //   if (totals[userSubject.status] !== undefined) {
        //     totals[userSubject.status] += 1;
        //   }
        // });
        return totals;
    }
    close() {
        this.$emit('input', false);
        this.$emit('dialogClosed', true);
        this.currentStep = 1;
        this.clearSelects = false;
    }
    clear() {
        this.$store.dispatch('selectedChanged', null);
        this.$store.dispatch('checkboxReset', true);
        this.detailedEvent = null;
        this.selectedLessonType = null;
        this.clearSelects = true;
        this.$nextTick(() => {
            this.close();
        });
    }
    eventChanged(event) {
        this.initialize();
    }
    lessonType(lessonType) {
        this.isLoadingLessonType = true;
        this.fetchLessonType(lessonType);
    }
    async currentStepChanged(currentStep, previousStep) {
        if (!this.detailedEvent) {
            return;
        }
        if (this.currentStep === 1 && currentStep !== previousStep) {
            this.initializeCurriculumStep();
        }
        if (this.currentStep > 2 && !this.isSubjectSummaryLoaded) {
            this.initializeOverviewStep();
        }
        if (this.currentStep > 2 && this.isSubjectSummaryLoaded && previousStep < 3) {
            this.initializeOverviewStep();
        }
        if (this.currentStep === 4) {
            await new EventModel({ id: this.detailedEvent.id }).update({
                is_volitional_subjects_finished: !!this.checkboxes.inviteCompleted,
                is_volitional_subjects_active: !!this.checkboxes.inviteNotInClassActive,
                is_volitional_subjects_unknown: !!this.checkboxes.inviteNotInPlP,
            });
            this.initializeOverviewStep();
        }
    }
    goToStep2() {
        if (this.selectedSubjects && this.selectedSubjects.length) {
            // this.isLoading = true;
        }
        this.currentStep = 2;
    }
    initializeOverviewStep() {
        if (this.detailedEvent && this.currentStep === 3 && this.selectedSubjects.length) {
            this.detailedEvent.subjects = this.selectedSubjects;
            this.isSubjectSummaryLoaded = false;
        }
        if (this.detailedEvent && this.detailedEvent.subjects && this.detailedEvent.subjects.length) {
            this.$store.dispatch('selectedChanged', this.detailedEvent.subjects);
        }
        this.resetSelectedSubjects();
        this.resetCalculation();
        this.getInvitedEventStudents();
        if (!this.curriculum.id) {
            this.initializeCurriculumStep();
        }
        if (!this.lessonTypes) {
            this.initializeLessonTypeStep();
        }
    }
    isMandatoryFor(user, row) {
        if (!this.invitations[row.subject]) {
            return false;
        }
        return this.invitations[row.subject].active.is_mandatory && row.level.is_current && ['old', 'busy', 'highlighted'].includes(row.status)
            || this.invitations[row.subject].finished.is_mandatory && row.level.is_current && ['finished'].includes(row.status)
            || this.invitations[row.subject].other.is_mandatory && !row.level.is_current;
    }
    isInvitedFor(user, row) {
        if (!this.invitations[row.subject]) {
            return false;
        }
        return this.invitations[row.subject].active.is_invited && row.level.is_current && ['old', 'busy', 'highlighted'].includes(row.status)
            || this.invitations[row.subject].finished.is_invited && row.level.is_current && ['finished'].includes(row.status)
            || this.invitations[row.subject].other.is_invited && !row.level.is_current;
    }
    fetchEvent() {
        new EventModel()
            .include(['areas', 'topics', 'levels', 'groups', 'users', 'roles', 'meta', 'room', 'subjects', 'parent', 'lesson_type'])
            .find(this.event.id)
            .then((event) => {
            this.detailedEvent = event;
            this.fillSelectFilter();
            this.setVolitionCheckboxes();
            if (this.hardlocked || (event.subjects && event.subjects.length)) {
                this.currentStep = 4;
                // this.initializeOverviewStep();
            }
            else {
                if (!this.filters.levels.length && !this.filters.periods.length) {
                    this.initializeCurriculumStep();
                }
            }
        });
    }
    getInvitedEventStudents() {
        this.isLoadingMandatoryUsers = true;
        const students = [];
        if (!this.detailedEvent) {
            return;
        }
        new EventModel()
            .include(['user'])
            .filter({ role: RolesEnum.STUDENT })
            .limit(300)
            .getInvitedStudents(this.detailedEvent.id || '')
            .then((events) => {
            events.forEach((event) => {
                if (event.user && event.user.id) {
                    const student = {
                        id: event.user.id,
                        is_mandatory: event.is_mandatory,
                        is_chosen: event.is_chosen,
                        is_default: event.is_default,
                    };
                    students.push(student);
                }
            });
            this.$set(this, 'totalStudents', students);
            if (this.selectedSubjects.length) {
                this.getSubjectSummary();
            }
            else {
                this.activeStudents = this.totalStudents;
                this.isSubjectSummaryLoaded = true;
                this.isLoadingMandatoryUsers = false;
            }
        });
    }
    fillSelectFilter() {
        if (this.detailedEvent) {
            this.detailedEvent.levels.forEach((level) => {
                if (level.id) {
                    this.filters.levels.push(level.id);
                }
            });
        }
        if (this.$store.state.period.id) {
            this.filters.periods.push(this.$store.state.period.id);
        }
    }
    resetCalculation() {
        this.totalStudents = [];
        this.activeStudents = [];
        this.finishedStudents = [];
        this.notInPlpStudents = [];
        this.notInClassActiveStudents = [];
    }
    getInvitedUsers() {
        const users = [];
        this.activeStudents.forEach((student) => {
            users.push({
                id: student.id,
                is_mandatory: student.is_mandatory,
                is_chosen: false,
            });
        });
        this.finishedStudents.forEach((student) => {
            users.push({
                id: student.id,
                is_mandatory: this.checkboxes.inviteCompleted ? false : student.is_mandatory,
                is_chosen: false,
            });
        });
        this.notInPlpStudents.forEach((student) => {
            users.push({
                id: student.id,
                is_mandatory: this.checkboxes.inviteNotInPlP ? false : student.is_mandatory,
                is_chosen: false,
            });
        });
        if (this.checkboxes.inviteNotInClassActive) {
            this.notInClassActiveStudents.forEach((student) => {
                users.push({
                    id: student.id,
                    is_mandatory: student.is_mandatory,
                    is_chosen: false,
                });
            });
            // this.invitedEventUsers.forEach((student: totalStudents) => {
            //   users.push({
            //     id: student.id,
            //     is_mandatory: this.checkboxes.inviteNotInPlP ? false : student.is_mandatory,
            //     is_chosen: false,
            //   })
            // });
        }
        return users;
    }
    sortByEventArea(subjects) {
        const areas = [...[], ...subjects];
        if (!this.detailedEvent || !this.detailedEvent.areas) {
            return subjects;
        }
        const areaIds = this.detailedEvent.areas.map((area) => {
            return area.id;
        });
        const selectedAreas = subjects.filter((subject) => {
            return areaIds.includes(subject.id);
        });
        const remainingAreas = subjects.filter((subject) => {
            return !areaIds.includes(subject.id);
        });
        return [...selectedAreas, ...remainingAreas];
    }
    setSelectedSubjects() {
        if (!this.detailedEvent) {
            return;
        }
        this.$store.dispatch('selectedChanged', this.detailedEvent.subjects);
    }
    getSubjectSummary() {
        if (!this.detailedEvent) {
            return;
        }
        new UserSubjectSummary()
            .filter({
            subjects: this.selectedSubjects.map((subject) => subject.id),
            statuses: [
                UserSubjectStatusEnum.BUSY,
                UserSubjectStatusEnum.HIGHLIGHTED,
                UserSubjectStatusEnum.OLD,
                UserSubjectStatusEnum.FINISHED,
                UserSubjectStatusEnum.CLOSED,
            ],
            event: this.detailedEvent.id,
        })
            .load()
            .then((response) => {
            const subjectSummary = new UserSubjectSummary().responseToModel(response);
            this.isSubjectSummaryLoaded = true;
            this.isLoadingMandatoryUsers = false;
            this.setSubjectStatusTotals(subjectSummary);
        });
    }
    parseEventDescription(description) {
        return replaceUrlsWithAnchorTags(description);
    }
    //
    // protected getSubjectSummaryLevelBusy() {
    //   this.isLoading = true;
    //   this.isSubjectSummaryLoaded = false;
    //   const subjects: string[] = [];
    //   this.selectedSubjects.forEach((subject: Subject) => {
    //     if (subject.id && ! subjects.includes(subject.id)) {
    //       subjects.push(subject.id);
    //     }
    //   });
    //   const filters = {
    //     subjects: subjects,
    //     statuses: ['highlighted', 'busy', 'old', 'finished'],
    //   };
    //   if (subjects.length){
    //     new Subject().filter(filters).include('level').summary().then((response: SubjectSummaryResponse) => {
    //       this.userSubjects.rows = response.data.data;
    //       this.userSubjects.totals.finished = this.userSubjects.rows.filter((studentSubject: SubjectSummaryResponseRow) => {
    //         return studentSubject.status === 'finished';
    //       }).length;
    //       this.userSubjects.totals.unfinished = this.userSubjects.rows.length - this.userSubjects.totals.finished;
    //       const invitations: UserInvitations = {};
    //       response.data.data.forEach((studentSubject: SubjectSummaryResponseRow) => {
    //         if (! invitations[studentSubject.subject]) {
    //           invitations[studentSubject.subject] = {
    //             active: {
    //               is_invited: false,
    //               is_mandatory: false,
    //             },
    //             finished: {
    //               is_invited: false,
    //               is_mandatory: false,
    //             },
    //             other: {
    //               is_invited: false,
    //               is_mandatory: false,
    //             },
    //           };
    //         }
    //       });
    //       this.$set(this, 'invitations', invitations);
    //       this.$nextTick(() => {
    //         this.isLoading = false;
    //       });
    //       this.setSubjectStatusTotals();
    //     });
    //   } else {
    //     if (!this.detailedEvent) {
    //       return;
    //     }
    //     this.setActiveUsers();
    //   }
    //   this.$nextTick(() => {
    //     this.isSubjectSummaryLoaded = true;
    //     this.isLoading = false;
    //   });
    // }
    // private setActiveUsers() {
    //   const properties = ['levels','groups'];
    //   let users: UserRow[] = [];
    //   properties.forEach((property: string) => {
    //     (this.detailedEvent as any)[property].forEach((model: Level | Group) => {
    //       if (!model.users) {
    //         return;
    //       }
    //       const mandatory = model.is_mandatory ? model.is_mandatory : false;
    //       const userModels = new Model().dataToModel({}, 'User', model.users as User[]);
    //       const students = userModels.filter((user: User) => {
    //         return user.hasRole('student');
    //       });
    //       students.forEach((student: User) => {
    //         const existingStudent = users.find((user: UserRow) => {
    //           return user.id === student.id;
    //         });
    //         if (!existingStudent) {
    //           users.push({
    //             id: student.id ? student.id : '',
    //             is_mandatory: mandatory,
    //             is_chosen: false,
    //           });
    //         } else if (model.is_mandatory) {
    //           existingStudent.is_mandatory = model.is_mandatory;
    //         }
    //       });
    //     });
    //   });
    //   this.activeStudents = users;
    // }
    deleteSubjectRow(subjectIndex) {
        this.selectedSubjects.splice(subjectIndex, 1);
        this.detailedEvent && this.detailedEvent.subjects ? this.detailedEvent.subjects.splice(subjectIndex, 1) : null;
        this.activeStudents = [];
        this.finishedStudents = [];
        this.notInPlpStudents = [];
        this.notInClassActiveStudents = [];
        this.setColumnTotals();
    }
    getSubjectSummaryLevelCompleted() {
        const filter = {
            subject: this.selectedSubjects,
            statuses: ['finished'],
        };
        // TODO: API call
    }
    getSubjectSummaryPlp() {
        const filter = {
            subject: this.selectedSubjects,
            statuses: ['highlighted'],
        };
        // TODO: API call
    }
    lessonTypeIcon(iconName) {
        return this.lessonTypeIcons[iconName];
    }
    fetchLessonType(id) {
        if (!id) {
            return;
        }
        new LessonType()
            .find(id)
            .then((lessonType) => {
            this.selectedLessonType = lessonType;
            this.isLoadingLessonType = false;
        });
    }
    filtersChanged(newValue, oldValue) {
        this.isLoading = true;
        this.areas = [];
        this.initializeCurriculumStep();
    }
    updateSubjectToEvent() {
        this.currentStep = 3;
        this.isLoadingStepThree = true;
        const subjects = this.selectedSubjects.map((subject) => {
            return subject.id;
        });
        let existingSubjects = [];
        if (this.detailedEvent && this.detailedEvent.areas) {
            existingSubjects = this.detailedEvent.areas.map((subject) => {
                return subject.id;
            });
        }
        let existingTopics = [];
        if (this.detailedEvent && this.detailedEvent.topics) {
            existingTopics = this.detailedEvent.topics.map((subject) => {
                return subject.id;
            });
        }
        new EventModel()
            .attachSubjectsToEvent(this.detailedEvent.id || '', [...existingSubjects, ...subjects, ...existingTopics])
            .then(() => {
            if (this.detailedEvent && this.detailedEvent.lesson_type) {
                this.fetchSubjects();
            }
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
        new EventModel({ id: this.detailedEvent.id })
            .update({
            description: this.detailedEvent ? this.detailedEvent.description : '',
            lesson_type: this.detailedEvent && this.detailedEvent.lesson_type ? this.selectedLessonType ? this.selectedLessonType.id : this.detailedEvent.lesson_type.id : '',
            is_volitional_subjects_finished: this.checkboxes.inviteCompleted,
            is_volitional_subjects_unknown: this.checkboxes.inviteNotInPlP,
            is_volitional_subjects_active: this.checkboxes.inviteNotInClassActive,
        })
            .then(() => { })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    fetchSubjects() {
        if (!this.isLoadingStepThree) {
            this.isLoadingStepThree = true;
        }
        new EventModel()
            .include(['subjects'])
            .find(this.event.id)
            .then((event) => {
            if (this.detailedEvent) {
                this.detailedEvent.subjects = event.subjects;
                this.isLoadingStepThree = false;
            }
            if (this.currentStep === 3) {
                this.initializeOverviewStep();
            }
        });
    }
    initializeCurriculumStep() {
        new Curriculum()
            .current()
            .filter(this.curriculumFilters)
            .first()
            .then((curriculum) => {
            this.curriculum = curriculum;
            if (curriculum.id) {
                this.getSubjects(this.curriculumFilters);
            }
        });
    }
    initializeLessonTypeStep() {
        new LessonType()
            .all()
            .then((types) => {
            this.lessonTypes = types;
        });
    }
    resetSelectedSubjects() {
        this.selectedSubjects.forEach((selectedSubject) => {
            selectedSubject ? selectedSubject.busy = [] : null;
            selectedSubject ? selectedSubject.highlighted = [] : null;
            selectedSubject ? selectedSubject.old = [] : null;
            selectedSubject ? selectedSubject.not_in_plp = [] : null;
            selectedSubject ? selectedSubject.finished = [] : null;
            selectedSubject ? selectedSubject.extra_highlighted = [] : null;
            selectedSubject ? selectedSubject.extra_busy = [] : null;
            selectedSubject ? selectedSubject.extra_old = [] : null;
        });
    }
    update() {
        if (this.isBeforeVisibleStudent) {
            return;
        }
        let callCount = 2;
        const users = this.getInvitedUsers() || [];
        const invited = [];
        const subjects = this.selectedSubjects.map((subject) => {
            return subject.id;
        });
        let existingSubjects = [];
        if (this.detailedEvent && this.detailedEvent.areas) {
            existingSubjects = this.detailedEvent.areas.map((subject) => {
                return subject.id;
            });
        }
        let existingTopics = [];
        if (this.detailedEvent && this.detailedEvent.topics) {
            existingTopics = this.detailedEvent.topics.map((subject) => {
                return subject.id;
            });
        }
        new EventModel()
            .attachSubjectsToEvent(this.detailedEvent.id || '', [...existingSubjects, ...subjects, ...existingTopics])
            .then(() => {
            callCount -= 1;
            if (callCount <= 0) {
                this.currentStep = 5;
                this.$emit('eventEditted');
            }
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
        new EventModel({ id: this.detailedEvent.id })
            .update({
            description: this.detailedEvent ? this.detailedEvent.description : '',
            lesson_type: this.detailedEvent && this.detailedEvent.lesson_type ? this.selectedLessonType ? this.selectedLessonType.id : this.detailedEvent.lesson_type.id : '',
            is_volitional_subjects_finished: this.checkboxes.inviteCompleted,
            is_volitional_subjects_unknown: this.checkboxes.inviteNotInPlP,
            is_volitional_subjects_active: this.checkboxes.inviteNotInClassActive,
            groups: this.detailedEvent && this.detailedEvent.groups ? this.detailedEvent.groups.map((group) => {
                return {
                    id: group.id,
                    is_mandatory: group.is_mandatory,
                };
            }) : [],
        })
            .then(() => {
            callCount -= 1;
            if (callCount <= 0) {
                this.currentStep = 5;
                this.$emit('eventEditted');
            }
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    /**
     * Sets users event of the selected group to mandatory based on the group.is_mandatory value
     *
     * @param group
     *
     */
    makeGroupMandatory(group) {
        if (!group.users) {
            return;
        }
        const selectedGroupUsers = [];
        group.users.forEach((groupUser) => {
            if (!groupUser || !groupUser.roles || groupUser.roles[0].id !== RolesEnum.STUDENT) {
                return;
            }
            if (!this.detailedEvent || !this.detailedEvent.users) {
                return;
            }
            const user = this.detailedEvent.users.find((eventUser) => {
                return eventUser.id === groupUser.id;
            });
            selectedGroupUsers.push(user);
        });
        const payload = {
            users: [],
        };
        selectedGroupUsers.forEach((user) => {
            payload.users.push({
                id: user.id,
                is_mandatory: group.is_mandatory,
            });
        });
        new EventModel({ id: this.event.id })
            .mandatory(payload)
            .then(() => {
            //
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    subjectStatusLabel(status) {
        if (!status) {
            return this.$tc(`idp.status.inactive`, 2);
        }
        const label = this.$store.state.labels.find((label) => {
            return label.key === status;
        });
        if (!label || label.value === label.key) {
            return this.$tc(`idp.status.${status}`, 2);
        }
        else {
            return label.value;
        }
    }
    setVolitionCheckboxes() {
        if (!this.detailedEvent) {
            return;
        }
        this.checkboxes.inviteCompleted = this.detailedEvent.is_volitional_subjects_finished || false;
        this.checkboxes.inviteNotInClassActive = this.detailedEvent.is_volitional_subjects_active || false;
        this.checkboxes.inviteNotInPlP = this.detailedEvent.is_volitional_subjects_unknown || false;
    }
    /**
     * Returns the totals for a subject.
     *
     * @param subject
     * @param isCurrent Determines whether the subject is for the users current level or not.
     */
    getUniqueStudentsForStatus(newStudents, statuses, subjectStatus) {
        const currentStudents = statuses[subjectStatus] ? statuses[subjectStatus] : [];
        currentStudents.forEach((student) => {
            const isDuplicateStudent = newStudents.findIndex((findStudent) => {
                const foundStudent = student.id.toString() === findStudent.id.toString();
                return foundStudent;
            }) !== -1;
            if (isDuplicateStudent) {
                return;
            }
            if (subjectStatus === 'finished') {
                const isInActiveStudents = this.activeStudents.findIndex((activeStudent) => {
                    return activeStudent.id === student.id;
                }) !== -1;
                if (isInActiveStudents) {
                    return;
                }
            }
            if (subjectStatus === 'not_in_plp') {
                const isInActiveStudents = [...this.activeStudents, ...this.finishedStudents].findIndex((activeStudent) => {
                    return activeStudent.id === student.id;
                }) !== -1;
                if (isInActiveStudents) {
                    return;
                }
            }
            newStudents.push(student);
        });
        return newStudents;
    }
    setColumnTotals() {
        // add statuses from each row into column arrays for total
        this.selectedSubjects.forEach((subject) => {
            if (subject.highlighted) {
                this.activeStudents = this.getUniqueStudentsForStatus(this.activeStudents, subject, 'highlighted');
            }
            if (subject.busy) {
                this.activeStudents = this.getUniqueStudentsForStatus(this.activeStudents, subject, 'busy');
            }
            if (subject.old) {
                this.activeStudents = this.getUniqueStudentsForStatus(this.activeStudents, subject, 'old');
            }
        });
        this.selectedSubjects.forEach((subject) => {
            if (subject.finished) {
                this.finishedStudents = this.getUniqueStudentsForStatus(this.finishedStudents, subject, 'finished');
            }
        });
        this.selectedSubjects.forEach((subject) => {
            if (subject.not_in_plp) {
                this.notInPlpStudents = this.getUniqueStudentsForStatus(this.notInPlpStudents, subject, 'not_in_plp');
            }
        });
        this.selectedSubjects.forEach((subject) => {
            if (subject.extra_highlighted) {
                this.notInClassActiveStudents = this.getUniqueStudentsForStatus(this.notInClassActiveStudents, subject, 'extra_highlighted');
            }
            if (subject.extra_busy) {
                this.notInClassActiveStudents = this.getUniqueStudentsForStatus(this.notInClassActiveStudents, subject, 'extra_busy');
            }
            if (subject.extra_old) {
                this.notInClassActiveStudents = this.getUniqueStudentsForStatus(this.notInClassActiveStudents, subject, 'extra_old');
            }
        });
        this.isSubjectSummaryLoaded = true;
    }
    setSubjectStatusTotals(userSubjectSummary) {
        const defaultStudents = this.totalStudents.filter((student) => student.is_default);
        const extraStudents = this.totalStudents.filter((student) => !student.is_default);
        this.selectedSubjects.forEach((subject) => {
            subject.not_in_plp = [];
            defaultStudents.forEach((student) => {
                const userSubject = userSubjectSummary.find((summary) => {
                    return summary.user === student.id && summary.subject === subject.id;
                });
                if (!userSubject) {
                    if (!subject.not_in_plp.some((currentStudent) => currentStudent.id === student.id)) {
                        subject.not_in_plp.push(student);
                    }
                }
                else {
                    const status = userSubject.status;
                    if (!status) {
                        return;
                    }
                    if (!subject[status]) {
                        subject[status] = [];
                    }
                    if (!subject[status].some((currentStudent) => currentStudent.id === student.id)) {
                        subject[status].push(student);
                    }
                }
            });
            extraStudents.forEach((student) => {
                const userSubject = userSubjectSummary.find((summary) => {
                    return summary.user === student.id && summary.subject === subject.id;
                });
                if (userSubject) {
                    const status = userSubject.status;
                    if (!status) {
                        return;
                    }
                    if (!subject[`extra_${status}`]) {
                        subject[`extra_${status}`] = [];
                    }
                    if (!subject[`extra_${status}`].some((currentStudent) => currentStudent.id === student.id)) {
                        subject[`extra_${status}`].push(student);
                    }
                }
            });
        });
        this.setColumnTotals();
    }
};
__decorate([
    Prop({ default: null }),
    __metadata("design:type", typeof (_a = typeof EventModel !== "undefined" && EventModel) === "function" ? _a : Object)
], EditEventDialog.prototype, "event", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], EditEventDialog.prototype, "hardlocked", void 0);
__decorate([
    Watch('event'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_b = typeof EventModel !== "undefined" && EventModel) === "function" ? _b : Object]),
    __metadata("design:returntype", void 0)
], EditEventDialog.prototype, "eventChanged", null);
__decorate([
    Watch('detailedEvent.lesson_type'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], EditEventDialog.prototype, "lessonType", null);
__decorate([
    Watch('currentStep'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Number]),
    __metadata("design:returntype", Promise)
], EditEventDialog.prototype, "currentStepChanged", null);
__decorate([
    Watch('filters', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], EditEventDialog.prototype, "filtersChanged", null);
EditEventDialog = __decorate([
    Component({
        components: {
            AsyncSelect,
            SelectFilter,
            LoaderCard,
            DataTable,
            AreaRow,
            AlertCard,
            StudentOverviewTableDialog,
            SubjectSearchDialog,
        },
        filters: {
            formatDay(date) {
                return DateTime.fromSQL(date).toFormat('c');
            },
            formatTime(time) {
                return !time ? '' : DateTime.fromFormat(time, 'yyyy-LL-dd HH:mm:ss').toFormat('HH:mm');
            },
            formatDate(date) {
                return !date ? '' : DateTime.fromFormat(date, 'yyyy-LL-dd HH:mm:ss').toFormat('dd-LL-yyyy');
            },
        },
    })
], EditEventDialog);
export default EditEventDialog;
